import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

import { CreateVehicleRoadWorthyCheckDto } from './create-vehicle-road-worthy-check.dto';

/**
 * Update vehicle road worthy check DTO
 */
export class UpdateVehicleRoadWorthyCheckDto extends CreateVehicleRoadWorthyCheckDto {
	@TransformInt()
	id!: number;
}
